import { MobileUserTDSReportConstants } from '../constants';

export function MobileUserTDSReport(state = {}, action) {
    switch (action.type) {
        case MobileUserTDSReportConstants.LOADING_REQUEST:
            return {
                ...state,
                loading: action.isbool
            };
        case MobileUserTDSReportConstants.GETALL_REQUEST:
            return {
                ...state,
                loading: true
            };
        case MobileUserTDSReportConstants.GETALL_SUCCESS:
            return {
                ...state,
                items: action.datas
            };
        case MobileUserTDSReportConstants.GETALL_FAILURE:
            return {
                ...state,
                error: action.error
            };
        case MobileUserTDSReportConstants.GETEXPORT_REQUEST:
            return {
                ...state,
                exporting: true
            };
        case MobileUserTDSReportConstants.GETEXPORT_SUCCESS:
            return {
                ...state,
                exportitems: action.datas
            };
        case MobileUserTDSReportConstants.GETEXPORT_FAILURE:
            return {
                ...state,
                error: action.error
            };
        default:
            return state
    }

}